import { render, staticRenderFns } from "./myBalance.vue?vue&type=template&id=277b74aa&scoped=true"
import script from "./myBalance.vue?vue&type=script&lang=js"
export * from "./myBalance.vue?vue&type=script&lang=js"
import style0 from "./myBalance.vue?vue&type=style&index=0&id=277b74aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b74aa",
  null
  
)

export default component.exports